/**
 * IMPORTANT: When adding a new route which has an item id like serviceId, calendarId, etc,
 * be sure to add redirect logic when switching companies in MenuCompaniesHeader.tsx
 */

export const ROUTE_AUTH = '/auth';
export const ROUTE_AUTH_SIGN_IN = '/auth/signin';
export const ROUTE_AUTH_SIGN_UP = '/auth/signup';
export const ROUTE_AUTH_USER_DETAILS = '/auth/signup/details';
export const ROUTE_ERROR = '/error';
export const ROUTE_COMPANIES_CREATE = '/create-company';
export const ROUTE_NOT_FOUND = '/not-found';
// Admin
export const ROUTE_ADMIN = '/admin';
// Admin gift card designs
export const ROUTE_ADMIN_GIFT_CARD_DESIGNS_SECTION =
  '/admin/gift-card-designs/:designId?';
export const ROUTE_ADMIN_GIFT_CARD_DESIGNS = '/admin/gift-card-designs';
export const ROUTE_ADMIN_GIFT_CARD_DESIGN =
  '/admin/gift-card-designs/:designId';
export const ROUTE_ADMIN_GIFT_CARD_DESIGNS_CREATE =
  '/admin/gift-card-designs/create';
// Admin payment history
export const ROUTE_ADMIN_PAYMENT_HISTORY = '/admin/payment-history';
// Admin refunds
export const ROUTE_ADMIN_REFUNDS = '/admin/refunds';
//admin stuck payments
export const ROUTE_ADMIN_STUCK_RESERVATIONS = '/admin/stuck-reservations';
// Creating company wizard
export const ROUTE_CREATE_COMPANY_WIZARD = '/create-company-wizard/:companyId';
export const ROUTE_CREATE_COMPANY_WIZARD_POPULAR_CATEGORIES = `${ROUTE_CREATE_COMPANY_WIZARD}/popular-categories`;
export const ROUTE_CREATE_COMPANY_WIZARD_AUTOMATION = `${ROUTE_CREATE_COMPANY_WIZARD}/automation`;
export const ROUTE_CREATE_COMPANY_WIZARD_TURNOVER = `${ROUTE_CREATE_COMPANY_WIZARD}/turnover`;
export const ROUTE_CREATE_COMPANY_WIZARD_CATEGORIES = `${ROUTE_CREATE_COMPANY_WIZARD}/categories`;
export const ROUTE_CREATE_COMPANY_WIZARD_COMPANY_TYPE = `${ROUTE_CREATE_COMPANY_WIZARD}/business-type`;
export const ROUTE_CREATE_COMPANY_WIZARD_TEAM_SIZE = `${ROUTE_CREATE_COMPANY_WIZARD}/team-size`;
export const ROUTE_CREATE_COMPANY_WIZARD_LOCATION = `${ROUTE_CREATE_COMPANY_WIZARD}/location`;
export const ROUTE_CREATE_COMPANY_WIZARD_WORKING_HOURS = `${ROUTE_CREATE_COMPANY_WIZARD}/working-hours`;
export const ROUTE_CREATE_COMPANY_WIZARD_INTEGRATIONS = `${ROUTE_CREATE_COMPANY_WIZARD}/integrations`;
export const ROUTE_CREATE_COMPANY_WIZARD_REFERENCE = `${ROUTE_CREATE_COMPANY_WIZARD}/reference`;
export const ROUTE_CREATE_COMPANY_WIZARD_SUCCESS = `${ROUTE_CREATE_COMPANY_WIZARD}/success`;
export const ROUTE_COMPANIES = '/my-companies/:companyId?';
export const ROUTE_COMPANY = '/my-companies/:companyId';
// Overview
export const ROUTE_COMPANY_OVERVIEW = '/my-companies/:companyId/overview';
export const ROUTE_COMPANY_OVERVIEW_CONTENT = `${ROUTE_COMPANY_OVERVIEW}/content`;
export const ROUTE_COMPANY_OVERVIEW_SETTINGS = `${ROUTE_COMPANY_OVERVIEW}/settings`;
export const ROUTE_COMPANY_OVERVIEW_ADMIN_SETTINGS = `${ROUTE_COMPANY_OVERVIEW}/admin-settings`;
// Products
export const ROUTE_PRODUCT_SECTION =
  '/my-companies/:companyId/products/:productId?';
export const ROUTE_PRODUCTS = '/my-companies/:companyId/products';
export const ROUTE_PRODUCT = '/my-companies/:companyId/products/:productId';
export const ROUTE_PRODUCT_CREATE = '/my-companies/:companyId/products/create';
// Gift cards
export const ROUTE_GIFT_CARD_SECTION =
  '/my-companies/:companyId/gift-cards/:giftCardId?';
export const ROUTE_GIFT_CARDS = '/my-companies/:companyId/gift-cards';
export const ROUTE_GIFT_CARD =
  '/my-companies/:companyId/gift-cards/:giftCardId';
export const ROUTE_GIFT_CARD_CREATE =
  '/my-companies/:companyId/gift-cards/create';
// Services
export const ROUTE_GIFT_CARD_USES = '/my-companies/:companyId/gift-card-uses';
export const ROUTE_GIFT_CARD_USES_SECTION =
  '/my-companies/:companyId/gift-card-uses/:activationCode?';
export const ROUTE_GIFT_CARD_STATISTICS =
  '/my-companies/:companyId/gift-card-statistics';
export const ROUTE_SERVICES_SECTION =
  '/my-companies/:companyId/services/:serviceId?';
export const ROUTE_SERVICES = '/my-companies/:companyId/services';
export const ROUTE_SERVICE = '/my-companies/:companyId/services/:serviceId';
export const ROUTE_SERVICE_CREATE = '/my-companies/:companyId/services/create';
// Service groups
export const ROUTE_SERVICE_GROUPS_SECTION =
  '/my-companies/:companyId/services/groups/:serviceGroupId?';
export const ROUTE_SERVICE_GROUPS = '/my-companies/:companyId/services/groups';
export const ROUTE_SERVICE_GROUP =
  '/my-companies/:companyId/services/groups/:serviceGroupId';
export const ROUTE_SERVICE_GROUP_CREATE =
  '/my-companies/:companyId/services/groups/create';
// Calendars
export const ROUTE_CALENDARS_SECTION =
  '/my-companies/:companyId/calendars/:calendarId?';
export const ROUTE_CALENDARS = '/my-companies/:companyId/calendars';
export const ROUTE_CALENDAR = '/my-companies/:companyId/calendars/:calendarId';
export const ROUTE_CALENDAR_CREATE =
  '/my-companies/:companyId/calendars/create';
// Statistics
export const ROUTE_COMPANY_STATISTICS =
  '/my-companies/:companyId/statistics/company';
export const ROUTE_TRANSACTIONS_STATISTICS =
  '/my-companies/:companyId/statistics/transactions';
export const ROUTE_DETAILED_STATISTICS =
  '/my-companies/:companyId/statistics/detailed';
export const ROUTE_TICKET_STATISTICS =
  '/my-companies/:companyId/statistics/tickets';
// Promo codes
export const ROUTE_PROMO_CODES = '/my-companies/:companyId/promo';
export const ROUTE_PROMO_CODES_CREATE = '/my-companies/:companyId/promo/create';
export const ROUTE_PROMO_CODES_SECTION =
  '/my-companies/:companyId/promo/:promoCodeId?';
// Integrations
export const ROUTE_INTEGRATION_API =
  '/my-companies/:companyId/integrations/api';
export const ROUTE_INTEGRATION_WEB_WIDGET =
  '/my-companies/:companyId/integrations/web-widget';
// Clients
export const ROUTE_COMPANY_CLIENTS = '/my-companies/:companyId/clients';
export const ROUTE_COMPANY_CLIENTS_SECTION =
  '/my-companies/:companyId/clients/:clientId?';
// Reservations
export const ROUTE_RESERVATIONS = '/my-companies/:companyId/reservations';
export const ROUTE_RESERVATIONS_WORK_HOURS =
  '/my-companies/:companyId/reservations/work-hours';
export const ROUTE_RESERVATION_TIME = `${ROUTE_RESERVATIONS}/time/:reservationId`;
export const ROUTE_RESERVATION_SLOT = `${ROUTE_RESERVATIONS}/slot/:slotId`;
export const ROUTE_RESERVATION_SLOT_SUMMARY = `${ROUTE_RESERVATION_SLOT}/summary`;
export const ROUTE_RESERVATION_SLOT_REJECT = `${ROUTE_RESERVATION_SLOT}/reject`;
export const ROUTE_RESERVATION_SLOT_CHECKOUT = `${ROUTE_RESERVATION_SLOT}/checkout`;
export const ROUTE_RESERVATION_SLOT_MOVE_TIME = `${ROUTE_RESERVATION_SLOT}/move`;
export const ROUTE_RESERVATION_SLOT_CLIENTS = `${ROUTE_RESERVATION_SLOT}/clients`;
export const ROUTE_RESERVATION_SLOT_CLIENTS_CHECKED_IN = `${ROUTE_RESERVATION_SLOT}/checked-in-clients`;
export const ROUTE_RESERVATION_TIME_EDIT = `${ROUTE_RESERVATION_TIME}/edit`;
export const ROUTE_RESERVATION_SLOT_EDIT = `${ROUTE_RESERVATION_SLOT}/edit`;
export const ROUTE_RESERVATION_SLOT_UPDATE = `${ROUTE_RESERVATION_SLOT}/update`;
export const ROUTE_RESERVATIONS_CREATE =
  '/my-companies/:companyId/reservations/create';
export const ROUTE_RESERVATIONS_CREATE_STEP_CALENDARS = `${ROUTE_RESERVATIONS_CREATE}/calendars`;
export const ROUTE_RESERVATIONS_CREATE_STEP_SLOT = `${ROUTE_RESERVATIONS_CREATE}/slot`;
export const ROUTE_RESERVATIONS_CREATE_STEP_TIME = `${ROUTE_RESERVATIONS_CREATE}/time`;
export const ROUTE_RESERVATIONS_CREATE_STEP_TIME_CLIENT = `${ROUTE_RESERVATIONS_CREATE_STEP_TIME}/client`;
export const ROUTE_RESERVATIONS_CREATE_STEP_TIME_BUSINESS = `${ROUTE_RESERVATIONS_CREATE_STEP_TIME}/business`;
export const ROUTE_RESERVATIONS_WINDOW_CLOSURE = `${ROUTE_RESERVATIONS}/window-closure/:windowClosureId`;
// Reviews
export const ROUTE_REVIEWS = '/my-companies/:companyId/reviews';
export const ROUTE_REVIEWS_SECTION =
  '/my-companies/:companyId/reviews/:reviewId?';
// Campaigns
export const ROUTE_CAMPAIGNS = '/my-companies/:companyId/campaigns';
export const ROUTE_CAMPAIGN = '/my-companies/:companyId/campaigns/:campaignId';
export const ROUTE_CAMPAIGN_SETUP = '/my-companies/:companyId/campaigns/setup';
export const ROUTE_CAMPAIGNS_CREATE =
  '/my-companies/:companyId/campaigns/create';
export const ROUTE_CAMPAIGNS_SECTION =
  '/my-companies/:companyId/campaigns/:campaignId?';
// Venues
export const ROUTE_VENUES = '/my-companies/:companyId/venues';
export const ROUTE_VENUES_SECTION = `${ROUTE_VENUES}/:venueId?`;
export const ROUTE_VENUE = `${ROUTE_VENUES}/:venueId`;
export const ROUTE_VENUE_CREATE = `${ROUTE_VENUES}/create`;
// Billing
export const ROUTE_INVOICES = '/my-companies/:companyId/invoices';
export const ROUTE_ONLINE_PAYMENTS = '/my-companies/:companyId/online-payments';
export const ROUTE_COMPANY_SUBSCRIPTIONS =
  '/my-companies/:companyId/subscriptions';
export const ROUTE_STRIPE_SETUP = '/stripe/finish';
// Settings
export const ROUTE_COMPANY_LEGAL_INFO = '/my-companies/:companyId/legal';
// User Roles
export const ROUTE_USER_ROLES_SECTION =
  '/my-companies/:companyId/user-roles/:accessId?';
export const ROUTE_USER_ROLES = '/my-companies/:companyId/user-roles';
export const ROUTE_USER_ROLES_DETAILS =
  '/my-companies/:companyId/user-roles/:accessId';
export const ROUTE_USER_ROLES_CREATE =
  '/my-companies/:companyId/user-roles/create';
// Notification
export const ROUTE_NOTIFICATIONS = '/my-companies/:companyId/notifications';
export const ROUTE_NOTIFICATION = `${ROUTE_NOTIFICATIONS}/:notificationId`;
export const ROUTE_NOTIFICATIONS_SECTION = `${ROUTE_NOTIFICATION}?`;
export const ROUTE_NOTIFICATION_CREATE = `${ROUTE_NOTIFICATIONS}/create`;
// Reservation scanner kiosk
export const ROUTE_RESERVATION_SCANNER_KIOSK =
  '/my-companies/:companyId/reservation-scanner-kiosk';
// Activity logs
export const ROUTE_ACTIVITY_LOGS = '/my-companies/:companyId/activity-logs';

export const getPath = (route: string, params?: Record<string, string>) => {
  if (!params) {
    return route;
  }

  let newRoute = route;
  Object.keys(params).forEach((key) => {
    newRoute = newRoute.replace(`:${key}?`, params[key]);
    newRoute = newRoute.replace(`:${key}`, params[key]);
  });

  return newRoute;
};
